
import Vue from 'vue'

export default Vue.extend({
   name: 'AgreeGateComponent',
   props: {
      value: Boolean,
      validate: { type: Boolean, default: false },
   },
   data() {
      return {
         initialValue: false,
         innerValue: false,
         dirty: false,
      }
   },
   computed: {
      validationFailed(): boolean {
         if (!this.validate && !this.dirty) {
            return false
         }
         return !this.innerValue
      },

      helpBlock(): string {
         return `You must agree to the terms and conditions.`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: boolean) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
})
